import { transTime2, buildSessionMsg } from '../nim/utils/timeUtils';
import { buildEmoji } from "../nim/utils/emoji";
// 聊天记录时间过滤器
const chatRecord = (val) => {
    return transTime2(val)
}

// 头像名字过滤器
const userNameFilter = (val) => {
    if (val) {
        if (val.length >= 2) {
            return val.substring(val.length - 2);
        } else {
            return val;
        }
    }
}

// 表情过滤器
const emojiFilter = (val) => {
    return buildEmoji(val)
}

// 回话列表最后一条消息过滤
// const chatListLastmessage = (val) => {
//     return buildSessionMsg(val);
// }

export {
    chatRecord,
    userNameFilter,
    emojiFilter,
    // chatListLastmessage
}


// WEBPACK FOOTER //
// ./src/filters/index.js